import {createContext, useContext, useMemo} from 'react';
import useId from 'hooks/useId';
import {noop} from 'lodash';
import {TooltipWrapperProps} from './types';

type TooltipWrapperContextProps = {
    setTooltipRef: (id: string, element: HTMLElement | null) => void;
} & Partial<TooltipWrapperProps>;

export const TooltipWrapperContext = createContext<TooltipWrapperContextProps>({
    setTooltipRef: noop,
});

export const useTooltip = () => {
    const uniqueId = useId();
    const data = useContext(TooltipWrapperContext);

    return useMemo(
        () => ({
            setTooltipRef: (element: HTMLElement | null, suffixKey?: string) =>
                data.setTooltipRef(
                    suffixKey ? `${uniqueId}-${suffixKey}` : uniqueId,
                    element,
                ),
        }),
        [data, uniqueId],
    );
};
